module.exports = __webpack_public_path__ + "img/step4.2540ff94.png";